module.exports = __webpack_public_path__ + "static/media/manual_placements_place_new_sections.7dd9a663.mov";